/* LIGMA theme: small, dependency-free enhancements. Everything works without JS except the mobile menu, which needs it. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Light / dark toggle (dark is the default; storage may be blocked, so wrap it)
  document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
    function paint() {
      var light = root.dataset.theme === 'light';
      btn.setAttribute('aria-pressed', light ? 'true' : 'false');
      btn.textContent = light ? 'Dark mode' : 'Light mode';
    }
    paint();
    btn.addEventListener('click', function () {
      var next = root.dataset.theme === 'light' ? 'dark' : 'light';
      root.dataset.theme = next;
      try { localStorage.setItem('ligma-theme', next); } catch (e) { /* storage unavailable */ }
      paint();
    });
  });

  // Mobile menu: a native modal <dialog> gives focus trapping and Escape for free
  var dialog = document.querySelector('[data-menu-dialog]');
  if (dialog && typeof dialog.showModal === 'function') {
    document.querySelectorAll('[data-menu-open]').forEach(function (b) {
      b.addEventListener('click', function () { dialog.showModal(); });
    });
    dialog.querySelectorAll('[data-menu-close]').forEach(function (b) {
      b.addEventListener('click', function () { dialog.close(); });
    });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', function () {
      var opener = document.querySelector('[data-menu-open]');
      if (opener) opener.focus();
    });
  }

  // Header turns solid after a little scroll
  var header = document.querySelector('[data-header]');
  if (header) {
    var solid = ['border-hair', 'bg-bg/95', 'backdrop-blur'];
    var flat = ['border-transparent', 'bg-bg'];
    var onScroll = function () {
      var on = window.scrollY > 24;
      solid.forEach(function (c) { header.classList.toggle(c, on); });
      flat.forEach(function (c) { header.classList.toggle(c, !on); });
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Fade-and-rise on scroll (skipped entirely under reduced motion)
  var reveals = document.querySelectorAll('[data-reveal]');
  if (reveals.length) {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }
  }

  // Plain-language help for spec rows: a real button, not a hover tooltip
  document.querySelectorAll('[data-infotip]').forEach(function (btn) {
    var target = document.getElementById(btn.getAttribute('aria-controls'));
    if (!target) return;
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      target.hidden = open;
    });
  });

  // Optional decorative background loop: wide screens only, never under reduced motion or Save-Data, always pausable (WCAG 2.2.2)
  document.querySelectorAll('[data-hero-video]').forEach(function (video) {
    var saveData = navigator.connection && navigator.connection.saveData === true;
    var wide = window.matchMedia('(min-width: 1024px)').matches;
    var toggle = document.querySelector('[data-video-toggle]');
    if (reduceMotion || saveData || !wide) return;
    video.addEventListener('playing', function () {
      video.classList.remove('opacity-0'); video.classList.add('opacity-100');
      if (toggle) { toggle.hidden = false; toggle.textContent = 'Pause background motion'; toggle.setAttribute('aria-pressed', 'false'); }
    });
    video.addEventListener('pause', function () { if (toggle) { toggle.textContent = 'Play background motion'; toggle.setAttribute('aria-pressed', 'true'); } });
    if (toggle) toggle.addEventListener('click', function () { if (video.paused) video.play(); else video.pause(); });
    video.src = video.dataset.src;
    var p = video.play(); if (p && p.catch) p.catch(function () { /* autoplay blocked: stays hidden */ });
  });
})();
